import CustomButton from "@components/buttons/CustomButton";
import GlobalTextInputField from "@components/inputs/GlobalTextInputField";
import SlidingPanel from "@components/sliders/SlidingPanel";
import { institutionApis } from "@services/apis/Institution";
import { useState } from "react";
import useSnackbarMessage from "../../../utils/HandleSuccessErrorSnackbars";

interface AddCpgCommisionSliderProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (success: boolean) => void;
}

const AddCommissionSlider: React.FC<AddCpgCommisionSliderProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  const [depositFee, setDepositFee] = useState<number | undefined>(undefined);
  const [withdrawalFee, setWithdrawalFee] = useState<number | undefined>(
    undefined
  );
  const [loading, setLoading] = useState<boolean>(false);
  const { handleSuccess, handleError } = useSnackbarMessage();

  const handleSubmit = async () => {
    try {
      setLoading(true);
      await institutionApis.addCPGCommission({
        depositFee: depositFee || 0,
        withdrawalFee: withdrawalFee || 0,
      });
      handleSuccess({ message: "CPG Commission added successfully" });
      onConfirm(true);
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.msg ||
        "Updating status failed. Please try again.";
      handleError({ message: errorMessage });
    } finally {
      setLoading(false);
    }
  };

  return (
    <SlidingPanel
      showConfirm={false}
      isOpen={isOpen}
      isSlider={false}
      isMobile={false}
      heading={"Add CPG Commission"}
      onClose={() => {
        onClose();
      }}
    >
      <div className="flex flex-col p-[16px] gap-[16px] overflow-y-auto">
        <GlobalTextInputField
          type="number"
          title="Deposit Fee"
          placeholder="Enter deposit fee here"
          value={depositFee?.toString() || ""}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setDepositFee(Number(e.target.value))
          }
        />
        <GlobalTextInputField
          type="number"
          title="Withdrawal Fee"
          placeholder="Enter withdrawal fee here"
          value={withdrawalFee?.toString() || ""}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setWithdrawalFee(Number(e.target.value))
          }
        />
        <CustomButton
          isActive={true}
          isButtonLoading={loading}
          onClick={handleSubmit}
          text="SUBMIT"
        />
      </div>
    </SlidingPanel>
  );
};

export default AddCommissionSlider;
